import * as React from "react";
import {Component, Fragment} from "react";

class Share extends Component {

	constructor(props) {
		super(props);
		this.handleClick = this.handleClick.bind(this);
	}

	handleClick(type, link) {
		let target = false;
		if(type === 'facebook') {
			target = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(link)}&amp;quote=WOUNDWO Konfigurator`;
		}
		if(type === 'mail') {
			const str = `Hallo, ich habe eine Konfiguration bei WOUNDWO erstellt: ${link}`
			target = `mailto:?body=${encodeURIComponent(str)}`
		}
		if(type === 'whatsapp') {
			const str = `Hallo, ich habe eine Konfiguration bei WOUNDWO erstellt: ${link}`
			target = `https://wa.me/?text=${encodeURIComponent(str)}`
		}
		if(target) {
			if(type === 'facebook' || type === 'whatsapp') {
				window.open(target, '_blank');
			} else {
				window.location.href = target;
			}
		}
	}

	render() {

		const {code} = this.props;
		const link = `https://konfigurator.woundwo.com/config/${code}`;

		return (
			<Fragment>
				<div id="share">
					<div className="row align-items-center">
						<div className="col-4 text-center">
							<button type="button" className="btn btn-default" onClick={() => this.handleClick('facebook', link)} >
								<i className="fab fa-facebook-f" />
							</button>
							<small className="text-muted">Facebook</small>
						</div>
						<div className="col-4 text-center">
							<button type="button" className="btn btn-default" onClick={() => this.handleClick('mail', link)} >
								<i className="far fa-envelope" />
							</button>
							<small className="text-muted">Mail</small>
						</div>
						<div className="col-4 text-center">
							<button type="button" className="btn btn-default" onClick={() => this.handleClick('whatsapp', link)} >
								<i className="fab fa-whatsapp" />
							</button>
							<small className="text-muted">WhatsApp</small>
						</div>
					</div>
					<input type="text" className="form-control form-control-sm mt-3" defaultValue={link} readOnly={true} />
				</div>
			</Fragment>
		);
	}
}

export default Share;
